<spinner class={state.active ? '' : 'transparent'}>
  <script>
    import search from '../lib/search.instance'

    export default class {
      onBeforeMount(props, state) {
        state.active = false

        this.on('search-count-change', event => {
          const count = event.data.count
          this.update({active: count > 0})
        })
      }
    }
  </script>
</spinner>
